import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme:{
        themes: {
            light:{
                primary: '#f44336',
                secondary: '#fff',
                listcolor: '#000000',
                tabbackground: '#111111',
                Wins: '#007b1c',
                Losses: '#dc4647',
                Draws: '#62aaf9',
            }
        }
    }
});
